/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { UserService } from '../../../core/services/user.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { PopupService } from './../../../core/services/popup.service';



/**
 * @export
 * @class LocoStatusContainerDataRowComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-container-data-row',
  templateUrl: './loco-status-container-data-row.component.html',
  styleUrls: ['./loco-status-container-data-row.component.scss']
})

export class LocoStatusContainerDataRowComponent implements OnInit, AfterViewInit {

  @Input() locoStatus: LocoDetail;
  @Input() index: number;
  @Input() totalRow: number;
  @Output() locoSelectionEvent = new EventEmitter();
  @Output() doubleEnterEvent = new EventEmitter();
  @Output() singleEnterEvent = new EventEmitter();
  firstEnterClickTime: number;
  clickCount = 0;
  @Output() onLocoSelect: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Input() locoStatusDataArr: Array<LocoDetail>;
  @Output() searchClickEvent: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() removeLocoEvent: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() updateDataStoreEvent = new EventEmitter();
  cancelPlanErrorPopup: boolean;
  configData: any;
  tabIndex: number;
  locoCountCounter: number;
  /**
   * Creates an instance of LocoStatusContainerDataRowComponent.
   * @param {AppUtilityService} appUtilityService
   * @param {PopupService} popupService
   *
   * @memberOf LocoStatusContainerDataRowComponent
   */
  constructor(private appUtilityService: AppUtilityService,
    private popupService: PopupService,
    private configService: ConfigService,
    private messageHandlerService: MessageHandlerService,
    private staticDataStoreService: StaticDataStoreService, 
    public user: UserService) {
  }


  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  ngOnInit() {
    this.configData = this.configService.getConfigData();
    this.tabIndex = this.configData.tabIndex.detailPage + 10;
  }

  /**
   * Invoked after view is initialized.
   * @memberof LocoStatusContainerDataRowComponent
   */
  ngAfterViewInit() {
    if ((this.index || this.index > -1) && this.totalRow && (this.index === this.totalRow - 1)) {
      const rowTextBox = document.getElementById('locoStatusSearchTextBox' + this.index);
      if (rowTextBox) {
        setTimeout(() => {
          rowTextBox.focus();
        }, 10);
      }
    }
  }

  /**
   * Clear text from loco search text.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  removeLocomotiveId() {
    if (this.locoStatus) {
      this.locoStatus.isLocoError = false;
      this.locoStatus.searcheLocomotiveIdentifier = '';
      this.locoStatus.isLocoStatusLoaded = false;
      this.locoStatus.isLocoSelected = false;
      if (this.locoStatus.locomotiveIdentifier) {
        this.locoStatus.locomotiveIdentifier = '';
      }
      this.locoStatus.index = this.index;
      this.removeLocoEvent.emit(this.locoStatus);
    }
  }

  /**
   * Formatting of loco search text as per entered loco id and make service call when double enter triggered.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  loadLocoSearchText() {
    this.locoCountCounter = 0;
    if (this.locoStatus && this.locoStatus.searcheLocomotiveIdentifier) {
      this.locoStatus.locomotiveIdentifier = this.appUtilityService.formatLocomotiveId(this.locoStatus.searcheLocomotiveIdentifier);
      if (this.appUtilityService.isValidLocomotiveId(this.locoStatus.locomotiveIdentifier)) {
        this.locoStatus.searcheLocomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(this.locoStatus.searcheLocomotiveIdentifier);
        if (this.appUtilityService.isValidLocomotiveId(this.locoStatus.searcheLocomotiveIdentifier)) {

            //check if loco already exists
            for(var x = 0; x < this.locoStatusDataArr.length; x++)
            {
                if(this.locoStatusDataArr[x].searcheLocomotiveIdentifier === this.locoStatus.searcheLocomotiveIdentifier )
                  this.locoCountCounter++;
            }
            if(this.locoCountCounter >= 2)
            {
              this.locoStatus.isLocoError = true;
              this.locoStatus.locoErrorMessage = this.configData.messages.locomotiveAlreadyExists;
            }
            else
              this.locoStatus.isLocoError = false;
        } else {
          this.locoStatus.isLocoError = true;
          this.locoStatus.locoErrorMessage = this.configData.messages.invalidLocomotiveId;
        }
      } else {
        this.locoStatus.isLocoError = true;
        this.locoStatus.locoErrorMessage = this.configData.messages.invalidLocomotiveId;
      }
    }
    if (this.locoStatus.searcheLocomotiveIdentifier && this.locoStatus.searcheLocomotiveIdentifier.trim().length > 0) {
      const searchTextBox = document.activeElement;
      if (searchTextBox && document.getElementById('locoStatusSearchTextBox' + (this.totalRow - 1)) &&
        document.getElementById('locoStatusSearchTextBox' + (this.totalRow - 1)) === searchTextBox) {
        this.singleEnterEvent.emit();
      } else {
        const searchTextId = document.getElementById('locoStatusSearchTextBox' + (this.index + 1));
        if (searchTextId && searchTextId !== null) {
          searchTextId.focus();
        }
      }
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
      this.doubleEnterEvent.emit();
    }
    this.updateDataStoreEvent.emit();
  }

  /**
   * Set page mode when dialog show.
   * @param {string} btnId
   * @memberof LocoStatusContainerDataRowComponent
   */
  setPageModeDialog(btnId: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }
  }

  /**
   * invoked when individual loco status search triggered.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  searchLoco() {
    if (this.locoStatus && this.locoStatus.searcheLocomotiveIdentifier) {
      this.locoStatus.locomotiveIdentifier = this.appUtilityService.formatLocomotiveId(this.locoStatus.searcheLocomotiveIdentifier);
      if (this.appUtilityService.isValidLocomotiveId(this.locoStatus.locomotiveIdentifier)) {
        this.locoStatus.searcheLocomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(this.locoStatus.searcheLocomotiveIdentifier);
        this.locoStatus.isLocoError = false;
        this.searchClickEvent.emit(this.locoStatus);
      } else {
        this.locoStatus.isLocoError = true;
        this.locoStatus.locoErrorMessage = this.configData.messages.invalidLocomotiveId;
      }
    }
  }
  /**
   * Set page mode for single enter click in locomotive id box.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  setPageMode(event) {
    this.popupService.setPageMode('Edit');
    this.popupService.setSubmitBtnId('locoStatusDoubleEnterId' + this.index);
  }

  /**
   * Invoked when make selection of loco.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  setSelectLoco(event) {
    if (this.user && this.user.isUserManagerOrDirector) {
      const locoStatus = _.find(this.locoStatusDataArr,
        { 'isLocoSelected': true });

      if (locoStatus) {
        if (this.locoStatus.isLocoSelected) {
          this.locoStatus.isLocoSelected = false;
        } else {
          this.locoStatus.isLocoSelected = true;
        }
      } else {
        this.locoStatus.isLocoSelected = true;
      }
      this.locoSelectionEvent.emit();
    }
  }

  /**
   * Invoked when delete the search loco status text and update the UI accordingly.
   * @param {any} event
   * @memberOf LocoStatusContainerDataRowComponent
   */
  updateSearchText(event) {
    if (!this.locoStatus.searcheLocomotiveIdentifier) {
      this.removeLocomotiveId();
    }
    if (this.locoStatus && this.locoStatus.isLocoStatusLoaded) {
      let searchText: string;
      if (this.locoStatus && this.locoStatus.locomotiveIdentifier) {
        searchText = this.appUtilityService.UIformatLocomotiveId(this.locoStatus.locomotiveIdentifier);
      }
      if ((event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= 65 && event.keyCode <= 97)) {
      }
    }
  }

  /**
   * This method shows lococmotive COntext menu.
   * @param {LocoDetail} loco
   * @memberOf LocoStatusContainerDataRowComponent
   */
  public showLocoContextMenu(loco: LocoDetail) {
    if (loco && loco.locomotiveIdentifier && loco.locomotiveIdentifier.length > 5) {
      loco.index = this.index;
      this.onLocoSelect.emit(loco);
    }
  }

  /**
   * Invoked for reset page mode.
   * @param {any} event
   * @memberOf LocoStatusContainerDataRowComponent
   */
  resetPageMode(event) {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
   * Invoked for cancel plan locomotive popup.
   * @memberOf LocoStatusContainerDataRowComponent
   */
  cancelPlanErrorOpr() {
    this.cancelPlanErrorPopup = false;
  }
}
